<template>
  <div class="IntervalIOReportListWeb">
    <v-simple-table dense fixed-header v-if="list.length > 0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="">{{ $t("DayName") }}</th>
            <th class="">{{ $t("EntryDate") }}</th>
            <th class="">{{ $t("EntryTime") }}</th>
            <th class="">{{ $t("ExitTime") }}</th>
            <th class="">{{ $t("ExitDate") }}</th>
            <th class="">{{ $t("type") }}</th>
            <th class="">{{ $t("status") }}</th>
            <th class="">{{ $t("level") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in list"
            :key="index"
            class="text-color-black"
            @contextmenu.stop="show($event,item)"
          >
          <!-- @contextmenu="show" -->
            <td>{{ item.enterDayName }}</td>
            <td>{{ item.beginDate }}</td>
            <td>{{ item.BeginTime }}</td>
            <td>{{ item.endTime }}</td>
            <td>{{ item.endDate }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.position }}</td>
            <td>{{ item.statusName }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- <IOContextMenu :showMenu="showMenu" :x="x" :y="y" /> -->
    <IOContextMenu ref="IOContextMenu" :x="x" :y="y" />
  </div>
</template>

<script>
import IOContextMenu from "../../widget/IOContextMenu.vue";
export default {
  components: { IOContextMenu },
  props: {
    list: Array,
  },
  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
    };
  },
  methods: {
    // show(e) {
    //   e.preventDefault();
    //   this.showMenu = false;
    //   this.x = e.clientX;
    //   this.y = e.clientY;
    //   this.$nextTick(() => {
    //     this.showMenu = true;
    //   });
    // },

    show(e,item) {
      debugger
      e.preventDefault();
      this.$refs.IOContextMenu.hideMenu();
      this.showMenu = false
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.$refs.IOContextMenu.showMenu(item);
      });
    },
  },
};
</script>

<style>
</style>